module.exports = __webpack_public_path__ + "static/media/landscape3.3daeee2d.jpg";